import { Input_Icon_default } from "./chunk-FFQCECON.js";
import { Input_Input_default } from "./chunk-FL5CCUQR.js";
import { Input_default } from "./chunk-YFDQNSO5.js";

// src/elements/Input/index.ts
var InputComponent = Input_default;
InputComponent.Icon = Input_Icon_default;
InputComponent.Icon.displayName = "Input.Icon";
InputComponent.Input = Input_Input_default;
InputComponent.Input.displayName = "Input.Input";
export { InputComponent };